import { computed } from 'nanostores'

import type { DeliveryZone } from '@/models/delivery-zone'

import { $deliveryZones, $zipDeliveryZoneIds } from './stores'

export const $getDeliveryZoneByZip = computed(
  [$zipDeliveryZoneIds, $deliveryZones],
  (zipDeliveryZoneIds, deliveryZones) => (zip: string) => {
    const deliveryZoneId = zipDeliveryZoneIds[zip]

    if (deliveryZoneId) {
      return deliveryZones[String(deliveryZoneId)]
    }

    return {} as DeliveryZone
  },
)
